export default {
  text: 'You earned {{points}} points ({{amount}}) on this order',
  button: 'Login and Claim Points',
};
